import { createReducer } from "deox";

import { commonDataSuccess, commonDataLoading, commonDataError } from "./commonStateActions";
import { CommonData } from "../../../types/types";

export interface CommonDataState {
  isInitialised: Boolean;
  isLoading: Boolean;
  isError: Boolean;
  data: CommonData | null;
}

const initialState: CommonDataState = {
  isInitialised: false,
  isLoading: false,
  isError: false,
  data: null,
};

const commonDataReducer = createReducer(initialState, (handleAction) => [
  handleAction(commonDataLoading, (state, { payload }) => ({
    ...state,
    data: payload,
    isInitialised: false,
    isLoading: true,
    isError: false,
  })),
  handleAction(commonDataSuccess, (state, { payload }) => ({
    ...state,
    data: payload,
    isInitialised: true,
    isLoading: false,
    isError: false,
  })),
  // Without this the store stayed isLoading/uninitialised forever, and consumers silently
  // read the fee-less placeholder payload as if it were real data.
  handleAction(commonDataError, (state) => ({
    ...state,
    isInitialised: false,
    isLoading: false,
    isError: true,
  })),
]);

export default commonDataReducer;
